<template>
  <div>
    <div class="offer-stage">
      <div class="row">
        <!-- Title -->
        <div class="stage-title">Oferty</div>
        <hr />
      </div>
      <div class="row">
        <div class="col-md-6">
          <button class="btn btn-outline-info" @click="updateWholesalersOffers">
            Aktualizuj oferty hurtowni
          </button>
        </div>
        <div class="col-md-6">
          <button class="btn btn-outline-info" @click="updateDrugstoresOffers">
            Aktualizuj oferty aptek
          </button>
        </div>
      </div>
      <div class="row">
        <label class="form-checkbox">
          <input type="checkbox" v-model="enableKamsoftOfferUpdate" />
          <i class="form-icon"> Zaktualizuj także oferty kamsoft</i>
        </label>
      </div>
      <div class="row">
        <OrdersManagerOffersList />
      </div>
    </div>
  </div>
</template>

<script>
import OrdersManagerOffersList from "./OrdersManagerOffersList.vue";
import {useOrdersManagerModule} from "@/state/pinia/ordersManagerModule";
import {useCommonAppModule} from "@/state/pinia";

export default {
  name: "OrdersManagerOffers",
  components: {
    OrdersManagerOffersList,
  },
  computed: {
    ordersModule(){
      return useOrdersManagerModule();
    },
    commonModule(){
      return useCommonAppModule();
    }
  },
  data() {
    return {
      elementsEnabled: true,
      opacityStyle: "opacity:1;",
      enableKamsoftOfferUpdate: false,
    };
  },
  methods: {
    updateWholesalersOffers() {
      var wholesalersOfferEndpoint = "/updateWholesalersOffers";
      var requestPayload = {
        offersUpdateEndpoint: wholesalersOfferEndpoint,
        enableKamsoftOfferUpdate: this.enableKamsoftOfferUpdate,
      };
      this.ordersModule.httpUpdateOrdersManagerOffers(requestPayload);
    },
    updateDrugstoresOffers() {
      var wholesalersOfferEndpoint = "/updateOtherDrugstoresOffers";
      var requestPayload = {
        offersUpdateEndpoint: wholesalersOfferEndpoint,
        enableKamsoftOfferUpdate: this.enableKamsoftOfferUpdate,
      };
      this.ordersModule.httpUpdateOrdersManagerOffers(requestPayload);
    },
  },
  watch: {
  },
  created() {
    this.commonModule.httpGetLicensedFeatures();
    this.commonModule.httpGetWorkingProfile();
  },
};
</script>

<style scoped>
.offer-stage {
  padding-left: 16px;
  padding-right: 16px;
}
</style>
